module.exports = __webpack_public_path__ + "static/media/reg3ru.cd6a3c38.pdf";